import { heroBadges, heroStats } from '@/mocks/home';
import { useToast } from '@/components/base/Toast';

export default function HeroSection() {
  const showToast = useToast();

  const scrollTo = (id: string) => {
    const target = document.getElementById(id);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="top" className="relative overflow-hidden border-b border-background-200 bg-background-50">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl"></div>
        <div className="absolute -bottom-24 left-1/3 h-64 w-64 rounded-full bg-accent-100/50 blur-3xl"></div>
      </div>

      <div className="relative mx-auto grid max-w-[1400px] grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-2 lg:gap-16">
        {/* left: text column */}
        <div data-reveal>
          <div className="flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-2 rounded-full bg-foreground-950 px-3 py-1.5 text-xs font-semibold tracking-wide text-primary-300">
              <i className="ri-fire-fill text-[13px]" aria-hidden="true"></i>
              今日热度持续走高
            </span>
            {heroBadges.map((badge) => (
              <span
                key={badge}
                className="rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-700"
              >
                {badge}
              </span>
            ))}
          </div>

          <h1 className="mt-6 font-heading text-3xl font-black leading-[1.2] tracking-tight text-foreground-950 md:text-5xl">
            撸撸射入口一站直达
            <span className="mt-2 block text-accent-600">最新网址与官网地址随时可查</span>
          </h1>

          <div className="mt-5 flex items-start gap-3">
            <span className="mt-2 h-12 w-1 shrink-0 rounded-full bg-primary-500"></span>
            <p className="max-w-xl text-sm leading-7 text-foreground-600 md:text-base">
              想找撸撸射最新入口？这里整理了官网地址、网址导航与最新访问方式，帮你快速找到可用入口、避免迷路。
              无论你是在找官网还是最新地址，都能在这里获取准确的导航信息，让每一次访问都轻松便捷。
            </p>
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <button
              type="button"
              onClick={() => scrollTo('entries')}
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-bold text-foreground-950 transition-colors hover:bg-primary-600"
            >
              <i className="ri-links-line text-base" aria-hidden="true"></i>
              查看最新入口
            </button>
            <button
              type="button"
              onClick={() => {
                showToast('访问指南已为你展开');
                scrollTo('guide');
              }}
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 bg-background-50 px-6 py-3.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-foreground-500 hover:bg-background-100"
            >
              <i className="ri-compass-3-line text-base" aria-hidden="true"></i>
              打不开？看访问指南
            </button>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-200 pt-6 sm:grid-cols-4">
            {heroStats.map((stat) => (
              <div key={stat.label}>
                <dt className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">{stat.value}</dt>
                <dd className="mt-1 text-xs text-foreground-500">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* right: magazine cover image panel */}
        <div data-reveal className="relative">
          <div className="relative mx-auto w-full max-w-[520px]">
            <div className="absolute -left-3 -top-3 hidden h-full w-full rounded-lg border border-accent-300 md:block"></div>
            <div className="relative overflow-hidden rounded-lg border border-background-300 bg-background-100">
              <div className="flex items-center justify-between border-b border-background-300 bg-background-50 px-4 py-2.5">
                <span className="flex items-center gap-1.5 text-[11px] font-semibold tracking-[0.2em] text-foreground-600">
                  <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-500"></span>
                  NO.01 · 本期导航
                </span>
                <span className="text-[11px] text-foreground-400">2026 / 10</span>
              </div>
              <div className="relative h-[300px] w-full sm:h-[360px] md:h-[420px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20style%20abstract%20composition%2C%20warm%20cream%20paper%20background%20with%20bold%20amber%20and%20vermilion%20geometric%20shapes%2C%20layered%20translucent%20frames%20and%20halftone%20print%20texture%2C%20minimal%20art%20direction%2C%20soft%20natural%20light%2C%20sophisticated%20vintage%20print%20aesthetic%2C%20high%20detail%2C%20harmonious%20warm%20palette&width=900&height=1080&seq=lulu-hero-cover-01&orientation=portrait"
                  alt="撸撸射入口导航封面"
                  title="撸撸射入口导航 · 最新网址与官网地址"
                  className="h-full w-full object-top object-cover"
                />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/40 to-transparent p-5">
                  <p className="text-[11px] font-semibold tracking-[0.25em] text-primary-300">撸撸射 · 入口专刊</p>
                  <p className="mt-1.5 font-heading text-lg font-bold leading-snug text-background-50">
                    官网 · 最新地址 · 备用线路，一页看懂
                  </p>
                </div>
              </div>
            </div>

            <div className="absolute -bottom-5 -right-2 flex items-center gap-3 rounded-lg border border-background-300 bg-background-50 px-4 py-3 shadow-sm md:-right-6">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-600">
                <i className="ri-verified-badge-line text-xl" aria-hidden="true"></i>
              </span>
              <div className="leading-tight">
                <p className="text-sm font-bold text-foreground-950">入口已核验</p>
                <p className="text-[11px] text-foreground-500">10 分钟前更新</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}